import { gql } from "@apollo/client";

export const CREATE_PLAN_CUIDADO_COMPLETE = gql`
    mutation createPlanCuidadoComplete(
        $planCuidadoId: Int!,
        $delegaciones: [AddPlanCuidadoDelegacionInput!]!,
        $clientes: [AddPlanCuidadoClienteInput!]!,
        $documentoLegales: AddPlanCuidadoDocumentoLegalInput,
        $documentoFacturaciones: [AddPlanCuidadoDocumentoFacInput!]!,
        $insumos: [AddPlanCuidadoInsumoInput!]!,
        $dietas: [AddPlanCuidadoDietaInput!]!,
        $fases: [AddPlanCuidadoFaseInput!]!,
        $profesionales: [AddPlanCuidadoFaseProfesionalInput!]!,
        $isEdition: Boolean!
         ){
        createPlanCuidadoComplete(
            input: {
                planCuidadoId: $planCuidadoId,
                delegaciones: $delegaciones,
                clientes: $clientes,
                documentoLegales: $documentoLegales,
                documentoFacturaciones: $documentoFacturaciones,
                insumos: $insumos,
                dietas: $dietas,
                fases: $fases,
                profesionales: $profesionales,
                isEdition: $isEdition
            }
        ) {
            nombre
        }
    }
`;